export default __webpack_public_path__ + "static/media/suitcase.afa6ac0e.png";